import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import OnzeWegwijzers from "./sections/OnzeWegwijzers";
import CertificeringenVertrouwen from "./sections/CertificeringenVertrouwen";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <OnzeWegwijzers />
      <CertificeringenVertrouwen />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}